import _ from 'lodash'
import 'flag-icon-css/css/flag-icon.css';
import codes from '@/f1/codes';
import { LangStatus } from '@/f1/service/i18n'
import Language from './language'


const _i18n_data = {
  crs_save : {
    EN: `no have changed`,
    KO: `no have changed`,
    JP : `変更されていません`,
  },
};

// path, paramater 만 지원
export default {
  name: 'RuleCRS',
  props: ['base_crs', 'custom_crs', 'search', 'summary', 'crs_count_preview'],
  components : {
    Language
  },
  watch: {
    custom_crs() {
      // console.log('custom_crs', this.custom_crs, x, y, 'updated')

      this.crs_body = Object.assign({}, this.crs_body, this.custom_crs)
      this.preview =  Object.assign({}, this.preview, { disable : 0, detect : 0, block : 0 })

      _.forEach(this.crs_body.policy_list, ff => {
        ff.mode_origin = this.codes.WAF_MODE_INTERFACE(ff.mode)
        ff.severity_origin = this.codes.WAF_SEVERITYS_EASY_TO_DESC(ff.severity)

        if(!ff.is_available) { return; }
        if(ff.level > 1) { return; }

        switch (this.codes.WAF_MODE_INTERFACE(ff.mode)) {
          case this.codes.WAF_MODE_OFF.VALUE: this.preview.disable += 1; break;
          case this.codes.WAF_MODE_DETECTIONONLY.VALUE: this.preview.detect += 1; break;
          case this.codes.WAF_MODE_ON.VALUE: this.preview.block += 1; break;
        }
      })
    }
  },
  computed: {
    total() { return _.filter(this.crs_body.policy_list, x => x.level < 2 && x.is_available === true).length },
    i18n_data() { return _i18n_data; },
  },
  data: () => {
    return {
      confirm_modal :false,
      is_search : false,
      policy_modal : false,
      all_open_status : false,
      codes,
      crs_body : { i18n : '' },
      max_count : 0,
      preview : {
        disable : 0, detect : 0, block : 0
      },


      // 이전 변수
      explain_modal_code :false,
      model : [],
      has_base_policy : false,
      lang : ''
    }
  },
  methods: {
    get_css(count=0) {
      if(count < 1) { return `width: ${count}px; height:5px; background: linear-gradient( to right, yellow, orange, red)` }
      // console.log(Math.round(count / _.sum(_.map(this.crs_body.policy_list, m => this.summary[m.key])) * 100 ))
      return `width: ${Math.round(count / _.sum(_.map(this.crs_body.policy_list, m => this.summary[m.key])) * 100 ) }%; height:5px; background: linear-gradient( to right, yellow, orange, red)`
    },
    // 하위 정책이 모두 미사용이면 메인 정책도 표시 불가
    is_available() {
      if(!this.base_crs || this.base_crs.is_available == false) { return false }

      if(this.base_crs.policy_list.length == _.filter(this.base_crs.policy_list, x => !x.is_available).length) {
        return false
      }

      return true
    },
    is_helight(rindex=-1, level=1) {
      if(!this.search) { return true }

      let x = this.search.toString().trim().toUpperCase()

      if(!this.base_crs.i18n['JP']){
        this.lang = 'EN'
      }else{
        this.lang = LangStatus
      }

      if(rindex < 0) {
        // 메인 표시 여부로 메인 및 서브 룰 검사
        // return this.base_crs.i18n[LangStatus].desc.toUpperCase().indexOf(x) > -1 ||
        // _.filter(this.base_crs.policy_list, p => p.is_available && p.level <= level && (p.key.startsWith(x) || p.i18n[(this.i18n || 'EN')].desc.toUpperCase().indexOf(x) > -1)).length > 0
        return this.base_crs.i18n[this.lang].desc.toUpperCase().indexOf(x) > -1 ||
          _.filter(this.base_crs.policy_list, p => p.is_available && p.level <= level && (p.key.startsWith(x) || p.i18n[(this.lang || 'EN')].desc.toUpperCase().indexOf(x) > -1)).length > 0
      } else {
        // 서브 룰에서 표시 여부 확인
        // return this.base_crs.i18n[LangStatus].desc.toUpperCase().indexOf(x) > -1 || this.base_crs.policy_list[rindex].key.startsWith(x) || this.base_crs.policy_list[rindex].i18n[(this.i18n || 'EN')].desc.toUpperCase().indexOf(x) > -1
        return this.base_crs.i18n[this.lang].desc.toUpperCase().indexOf(x) > -1 || this.base_crs.policy_list[rindex].key.startsWith(x) || this.base_crs.policy_list[rindex].i18n[(this.lang || 'EN')].desc.toUpperCase().indexOf(x) > -1
      }
    },
    get_random_color() {
      var letters = '0123456789ABCDEF'.split('');
      var color = '#';
      for (var i = 0; i < 6; i++ ) {
          color += letters[Math.round(Math.random() * 15)];
      }
      return color;
    },
    _get_keyword(crs) {
      // console.log('crs', crs)
      if(!crs.i18n) { return }


      if(crs.i18n['EN'].keyword.indexOf('APPLICATION') > -1) {

        // processing
        if(crs.i18n['EN'].keyword.indexOf('JAVA') > -1) { return 'img/processing/java_application_attack.png' }
        else if(crs.i18n['EN'].keyword.indexOf('LOG4J') > -1) { return 'img/processing/log4j.png' }
        else if(crs.i18n['EN'].keyword.indexOf('LFI') > -1) { return 'img/processing/local_file_inclusion.png' }
        else if(crs.i18n['EN'].keyword.indexOf('NODE') > -1) { return 'img/processing/node.png' }
        else if(crs.i18n['EN'].keyword.indexOf('INITIALIZATION') > -1) { return 'img/processing/crs_setup.png' }
        else if(crs.i18n['EN'].keyword.indexOf('PHP') > -1) { return 'img/processing/php_application_attack.png' }
        else if(crs.i18n['EN'].keyword.indexOf('RCE') > -1) { return 'img/processing/remote_command_execution.png' }
        else if(crs.i18n['EN'].keyword.indexOf('SESSION') > -1) { return 'img/processing/session_fixation.png' }
        else if(crs.i18n['EN'].keyword.indexOf('SQL') > -1) { return 'img/processing/sql_injection.png' }
        else if(crs.i18n['EN'].keyword.indexOf('XSS') > -1) { return 'img/processing/xss.png' }
        else if(crs.i18n['EN'].keyword.indexOf('RFI') > -1) { return 'img/processing/remote_file_inclusion.png' }
        else if(crs.i18n['EN'].keyword.indexOf('WCON') > -1) { return 'img/processing/wcon.png' }


      } else if(crs.i18n['EN'].keyword.indexOf('REQUEST') > -1) {
        // request
        if(crs.i18n['EN'].keyword.indexOf('BLOCKING') > -1) { return 'img/request/abnormal_request.png' }
        else if(crs.i18n['EN'].keyword.indexOf('COMMON') > -1) { return 'img/request/common_exceptions.png' }
        else if(crs.i18n['EN'].keyword.indexOf('CPANEL') > -1) { return 'img/exclusion/cpanel.png' }
        else if(crs.i18n['EN'].keyword.indexOf('NEXTCLOUD') > -1) { return 'img/exclusion/nextcloud.png' }
        else if(crs.i18n['EN'].keyword.indexOf('WORDPRESS') > -1) { return 'img/exclusion/wordpress.png' }
        else if(crs.i18n['EN'].keyword.indexOf('XENFORO') > -1) { return 'img/exclusion/xenforo.png' }
        else if(crs.i18n['EN'].keyword.indexOf('DOKUWIKI') > -1) { return 'img/exclusion/dokuwiki.png' }
        else if(crs.i18n['EN'].keyword.indexOf('DRUPAL') > -1) { return 'img/exclusion/drupal.png' }
        else if(crs.i18n['EN'].keyword.indexOf('INITIALIZATION') > -1) { return 'img/request/crs_setup.png' }
        else if(crs.i18n['EN'].keyword.indexOf('DOS') > -1) { return 'img/request/dos_protection.png' }
        else if(crs.i18n['EN'].keyword.indexOf('REPUTATION') > -1) { return 'img/request/ip_reputation.png' }
        else if(crs.i18n['EN'].keyword.indexOf('METHOD') > -1) { return 'img/request/method_enforcement.png' }
        else if(crs.i18n['EN'].keyword.indexOf('PROTOCOL-ENFORCEMENT') > -1) { return 'img/request/protocol_enforcement.png' }
        else if(crs.i18n['EN'].keyword.indexOf('PROTOCOL-ATTACK') > -1) { return 'img/request/protocol_attack.png' }
        else if(crs.i18n['EN'].keyword.indexOf('SCANNER') > -1) { return 'img/request/scanner_detection.png' }
        // else if(crs.i18n['EN'].keyword.indexOf('WCON') > -1) { return 'img/request/wcon.png' }

      } else {

        // response
        if(crs.i18n['EN'].keyword.indexOf('BLOCKING') > -1) { return 'img/response/abnormal_response.png' }
        else if(crs.i18n['EN'].keyword.indexOf('CORRELATION') > -1) { return 'img/response/correlation.png' }
        else if(crs.i18n['EN'].keyword.indexOf('IIS') > -1) { return 'img/response/iis_data_leakages.png' }
        else if(crs.i18n['EN'].keyword.indexOf('JAVA') > -1) { return 'img/response/java_data_leakages.png' }
        else if(crs.i18n['EN'].keyword.indexOf('PHP') > -1) { return 'img/response/php_data_leakages.png' }
        else if(crs.i18n['EN'].keyword.indexOf('SQL') > -1) { return 'img/response/sql_data_leakages.png' }
        else if(crs.i18n['EN'].keyword.indexOf('DATA') > -1) { return 'img/response/data_leakages.png' }


      }

      return ''
    },
    toggle_default_block() {
      (this.crs_body.policy_list || []).forEach(x => {
        if(x.level > 1) { return; }
        if(!x.is_available) { return }

        x.mode = codes.WAF_MODE_ON.VALUE
        x.is_change = x.mode_origin != codes.WAF_MODE_INTERFACE(x.mode)
        // delete x.level_origin // 향후 사용 가능
      })
    },
    toggle_default_detect() {
      (this.crs_body.policy_list || []).forEach(x => {
        if(x.level > 1) { return; }
        if(!x.is_available) { return }

        x.mode = codes.WAF_MODE_DETECTIONONLY.VALUE
        x.is_change = x.mode_origin != codes.WAF_MODE_INTERFACE(x.mode)
        // delete x.level_origin // 향후 사용 가능
      })
    },
    toggle_all_detect() {
      (this.crs_body.policy_list || []).forEach(x => {
        if(!x.is_available) { return }
        if(x.level > 1) { return; }

        x.mode = codes.WAF_MODE_DETECTIONONLY.VALUE
        x.is_change = x.mode_origin != codes.WAF_MODE_INTERFACE(x.mode)
        // delete x.level_origin // 향후 사용 가능
      })
    },
    toggle_all_block() {
      (this.crs_body.policy_list || []).forEach(x => {
        if(!x.is_available) { return }
        if(x.level > 1) { return; }

        x.mode = codes.WAF_MODE_ON.VALUE
        x.is_change = x.mode_origin != codes.WAF_MODE_INTERFACE(x.mode)
        // delete x.level_origin // 향후 사용 가능
      })
    },
    toggle_all_off() {
      (this.crs_body.policy_list || []).forEach(x => {
        if(!x.is_available) { return }
        if(x.level > 1) { return; }

        x.mode = codes.WAF_MODE_OFF.VALUE
        x.is_change = x.mode_origin != codes.WAF_MODE_INTERFACE(x.mode)
        // delete x.level_origin // 향후 사용 가능
      })
    },
    save() {
      // 저장 로직
      try {

        if(this.crs_body.is_toggle) {
          // 상태가 변경되어야 가능
          if(this.crs_body.is_toggle_status_origin == this.crs_body.is_toggle_status) { return this.$toastr.e(this.i18n_data['crs_save'][this.i18n]) }

        } else {
          // 정책 변경은 바로 바로 저장한다
          let is_change = _.filter((this.crs_body.policy_list || []), x => x.is_change === true).length > 0
          if(!is_change) { return this.$toastr.e(this.i18n_data['crs_save'][this.i18n]) }
        }

        _.forEach(this.crs_body.policy_list, f => { delete f.is_change })

        this.$parent.$emit("save", this.crs_body)
      } catch (e) { console.log(e) }
      finally {
        this.policy_modal = false
      }
    },
    cancel() {
      try {
        console.log('policy reset')
        // 수정 정책 초기화
        this.crs_body = Object.assign({}, this.crs_body, this.custom_crs);

        _.forEach(this.crs_body.policy_list || [], ff => {

          if(!ff.is_available) { return; }
          if(ff.level > 1) { return; }

          ff.is_change = false
          // ff.mode_origin = this.codes.WAF_MODE_INTERFACE(ff.mode)
          // ff.severity_origin = this.codes.WAF_SEVERITYS_EASY_TO_DESC(ff.severity)
          // console.log(ff.key, this.codes.WAF_MODE_INTERFACE(ff.mode_origin), '=>', ff.mode)
          ff.mode = this.codes.WAF_MODE_INTERFACE(ff.mode_origin)
          // console.log(ff.key, this.codes.WAF_MODE_INTERFACE(ff.mode_origin), '=>', ff.mode)
          ff.severity = this.codes.WAF_SEVERITY_DESC_EASY_TO_NUMBER(ff.severity_origin)
        })

      } catch (e) { console.log(e) }
      finally {
        this.policy_modal = false
      }
    },
    // 아래는 이전 함수, 향후 삭제 필요
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    load() {
      console.log('RuleCRS.vue', 'mounted');
      // 저장용 변수 선언
      this.crs_body = this.custom_crs ? JSON.parse(JSON.stringify(this.custom_crs)) : {}

      _.forEach(this.crs_body.policy_list, ff => {
        ff.mode_origin = this.codes.WAF_MODE_INTERFACE(ff.mode)
        ff.severity_origin = this.codes.WAF_SEVERITYS_EASY_TO_DESC(ff.severity)

        if(!ff.is_available) { return; }
        if(ff.level > 1) { return; }

        switch (this.codes.WAF_MODE_INTERFACE(ff.mode)) {
          case this.codes.WAF_MODE_OFF.VALUE: this.preview.disable += 1; break;
          case this.codes.WAF_MODE_DETECTIONONLY.VALUE: this.preview.detect += 1; break;
          case this.codes.WAF_MODE_ON.VALUE: this.preview.block += 1; break;
        }
      })
    },
    _escape(e) { e.key == 'Escape' ? this.cancel() : '' }
  },
  created: function() {   console.log('RuleCRS.vue', 'created'); },
  destroyed: function() {
    console.log('RuleCRS.vue', 'destroyed')
    document.removeEventListener('keydown', this._escape)
  },
  mounted: function() {
    this.load()
    document.addEventListener("keydown", this._escape, { passive : true })
  }
}
